module.exports = __webpack_public_path__ + "static/media/Settings-3.7b2b7251.png";